webpackJsonp([144945625933105],{

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _componentsModule = __webpack_require__(6);
	
	var _componentsModule2 = _interopRequireDefault(_componentsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubmissionPage = function SubmissionPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: _componentsModule2.default.pagetitle },
	      'Paper Submission'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Paper submission is handled via the CMT system. Please submit your paper at ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://cmt3.research.microsoft.com/MMSP2018', rel: 'noopener noreferrer' },
	        'cmt3.research.microsoft.com/MMSP2018'
	      )
	    )
	  );
	};
	
	exports.default = SubmissionPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-submission-js-65c98924b978b922a436.js